import { format } from 'date-fns';
import { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import calendarIcon from '../../../../../assets/images/icons/calendar.svg';
import MyModal from '../../../../../components/Modal';
import { ReactCalendarCustomStyle } from '../../../../../components/ReactCalendarCustomStyle';
import useThemeContext from '../../../../../contexts/theme';
import { Value } from '../../../types/CalendarTypes';
import { Container } from './styles';

interface PeriodFilterProps {
  selectedPeriod: Value;
  onPeriodChange: (value: Value) => void;
  onClearPeriod: () => void;
}

export default function PeriodFilter({
  selectedPeriod,
  onPeriodChange,
  onClearPeriod,
}: PeriodFilterProps) {
  const [modalShow, setModalShow] = useState(false);
  const { selectedTheme } = useThemeContext();

  const handlePeriodChange = (value: Value) => {
    onPeriodChange(value);
    setModalShow(false);
  };

  const formatPeriodLabel = () => {
    if (!selectedPeriod) return 'Filtrar por período';

    if (Array.isArray(selectedPeriod)) {
      const [start, end] = selectedPeriod;
      if (start && end) {
        return `${format(start, 'dd/MM/yyyy')} - ${format(end, 'dd/MM/yyyy')}`;
      }
    }

    return 'Filtrar por período';
  };

  return (
    <>
      <Container>
        <button
          type="button"
          onClick={() => setModalShow(true)}
          className="period-button"
        >
          <img src={calendarIcon} alt="calendar" className="primaryColor" />
          <span>{formatPeriodLabel()}</span>
        </button>

        {selectedPeriod && Array.isArray(selectedPeriod) && selectedPeriod[0] && selectedPeriod[1] && (
          <button
            type="button"
            onClick={onClearPeriod}
            className="clear-button"
            title="Limpar filtro de período"
          >
            ✕
          </button>
        )}
      </Container>

      <MyModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        title="Selecione o período"
        type="info"
        closeButtonLabel="Fechar"
        centeredBody
        modalBody={(
          <>
            {selectedTheme === 'dark' ? (
              <ReactCalendarCustomStyle>
                <Calendar
                  onChange={handlePeriodChange}
                  value={selectedPeriod}
                  selectRange
                  maxDate={new Date()}
                />
              </ReactCalendarCustomStyle>
            ) : (
              <Calendar
                onChange={handlePeriodChange}
                value={selectedPeriod}
                selectRange
                maxDate={new Date()}
              />
            )}
          </>
        )}
      />
    </>
  );
}
